<template>
  <div class="iu">
    <div class="iu-label" v-if="label">{{ label }}</div>
    <div class="iu-area">
      <!-- Preview -->
      <div v-if="value" class="iu-preview">
        <img :src="value" alt="Uploaded image" class="iu-thumb" />
        <div class="iu-actions">
          <button type="button" class="iu-btn iu-btn--change" @click="triggerFileInput">Change</button>
          <button type="button" class="iu-btn iu-btn--remove" @click="$emit('input', '')">Remove</button>
        </div>
      </div>
      <!-- Upload prompt -->
      <div v-else class="iu-dropzone" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
        <i class="material-icons iu-icon">cloud_upload</i>
        <div class="iu-text">Click or drag image to upload</div>
        <div class="iu-hint">Recommended: 600px wide, JPG or PNG</div>
      </div>
      <!-- Hidden file input -->
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        style="display:none"
        @change="handleFile"
      />
      <!-- Upload progress -->
      <div v-if="uploading" class="iu-uploading">Uploading…</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',

  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    onUpload: { type: Function, required: true },
  },

  data() {
    return {
      uploading: false,
    };
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },

    handleFile(e) {
      var files = e.target.files;
      if (files && files.length) {
        this.uploadFile(files[0]);
      }
    },

    handleDrop(e) {
      var files = e.dataTransfer.files;
      if (files && files.length) {
        this.uploadFile(files[0]);
      }
    },

    async uploadFile(file) {
      if (!file.type.startsWith('image/')) {
        this.$emit('error', 'Please select an image file');
        return;
      }
      this.uploading = true;
      try {
        var url = await this.onUpload(file);
        if (url) {
          this.$emit('input', url);
        }
      } catch (err) {
        this.$emit('error', 'Upload failed');
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>

<style scoped>
.iu {
  margin-bottom: 16px;
}
.iu-label {
  font-size: 13px;
  font-weight: 600;
  color: #5f6368;
  margin-bottom: 6px;
}
.iu-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border: 2px dashed #dadce0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: #fafbfc;
}
.iu-dropzone:hover {
  border-color: var(--primary-color, #3b86f5);
  background: #f0f6ff;
}
.iu-icon {
  font-size: 36px;
  color: #9aa0a6;
  margin-bottom: 8px;
}
.iu-text {
  font-size: 14px;
  color: #5f6368;
  font-weight: 500;
}
.iu-hint {
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 4px;
}
.iu-preview {
  position: relative;
  display: inline-block;
}
.iu-thumb {
  display: block;
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
  border: 1px solid #dadce0;
}
.iu-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.iu-btn {
  padding: 4px 12px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  background: #fff;
  color: #5f6368;
  transition: background 0.15s;
}
.iu-btn:hover {
  background: #f4f3ed;
}
.iu-btn--remove {
  color: #d93025;
  border-color: #d93025;
}
.iu-btn--remove:hover {
  background: #fce8e6;
}
.iu-uploading {
  margin-top: 8px;
  font-size: 13px;
  color: var(--primary-color, #3b86f5);
}
</style>
